<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-30 18:10:11
 * @LastEditTime: 2021-02-23 10:09:22
-->
<template>
  <div id="order">
    <div class="order-wrap">
      <el-table
        :data="tdata"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#ececf1', color: '#414750' }"
      >
        <el-table-column
          align="center"
          prop="t"
          label="交易Id"
        >
        </el-table-column>
        <el-table-column align="center" prop="o_t" label="原始交易Id">
        </el-table-column>
        <el-table-column align="center" prop="pd" label="SKU" width="100px">
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态" width="100px">
        </el-table-column>
        <el-table-column align="center" prop="channel" label="支付渠道">
        </el-table-column>
        <el-table-column align="center" prop="ex_time" label="过期时间">
        </el-table-column>
        <el-table-column align="center" prop="c_time" label="创建时间">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tdata", "visib"],
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
#order{
    width: 100%;
    height: 100%;
}
.order-wrap{
    height: 100%;
    overflow-y: scroll;
}
</style>